// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-AuthBar__myAccountPanel__root"};